<template>
  <div
    v-html="content"
    class="cart-popup__item-info amway-theme"
  ></div>
</template>

<script>
import { mapState } from 'vuex'
import { SURVEY_SAPPORO } from '@/store/actions/survey'

export default {
  name: 'SurveyPopupConsent',
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      props: state => state.popup.props
    }),
    content() {
      return this.props ? this.props.content : '';
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyPopupConsent.vue